export enum TipoProduto {
    "pizza" = "pizza",
    "industrializado" = "industrializado",
    "preparado" = "preparado",
    "peso" = "peso",
    "combo" = "combo"
}